import React from "react";
import { Tabs, Tab, Paper } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useLocation, useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => {
  const isDark = theme.mode === "dark" || theme.palette?.type === "dark";
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0,
      height: "100%",
      background: isDark ? "#121212" : "#ffffff",
    },
    tabsBar: {
      background: isDark ? "#121212" : "#ffffff",
      borderBottom: isDark
        ? "1px solid rgba(255,255,255,0.06)"
        : "1px solid rgba(0,0,0,0.06)",
      flexShrink: 0,
      padding: "0 16px",
      "& .MuiTabs-indicator": {
        height: 2,
        borderRadius: 2,
      },
      "& .MuiTab-root": {
        textTransform: "none",
        minHeight: 44,
        fontWeight: 500,
        fontSize: 13,
        color: isDark ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.65)",
      },
      "& .MuiTab-root.Mui-selected": {
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
    },
    body: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
  };
});

/**
 * Wrapper de hub com abas. Cada aba mapeia a uma rota; o conteúdo é o
 * componente da tab ativa (decidido pela URL atual).
 *
 * Props:
 *   tabs: [{ label, path, Component, match? (string|string[]) }]
 *
 * `match` é uma forma alternativa pra reconhecer paths derivados (ex.: detalhe
 * de contact-list). Quando `location.pathname` casar com `path` ou qualquer
 * `match`, a aba fica ativa e o `Component` é renderizado.
 */
const HubTabs = ({ tabs = [] }) => {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const history = useHistory();

  const matchTab = (tab, pathname) => {
    if (pathname === tab.path) return true;
    const ms = tab.match
      ? Array.isArray(tab.match)
        ? tab.match
        : [tab.match]
      : [];
    return ms.some((m) =>
      m instanceof RegExp ? m.test(pathname) : pathname.startsWith(m)
    );
  };

  const activeIdx = Math.max(
    0,
    tabs.findIndex((t) => matchTab(t, location.pathname))
  );
  const ActiveComp = tabs[activeIdx]?.Component;

  return (
    <Paper className={classes.root} elevation={0} square>
      <Tabs
        value={activeIdx}
        onChange={(_, idx) => {
          const target = tabs[idx];
          if (target && target.path !== location.pathname) {
            history.push(target.path);
          }
        }}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabsBar}
      >
        {tabs.map((t) => (
          <Tab key={t.path} label={t.label} />
        ))}
      </Tabs>
      <div className={classes.body}>
        {ActiveComp ? <ActiveComp /> : null}
      </div>
    </Paper>
  );
};

export default HubTabs;
